import { resolve } from "node:path";

export const getCWD = (rawCWD: string) =>
  typeof rawCWD === "string" && rawCWD !== "undefined" ? resolve(rawCWD) : ".";
